import z from 'zod';

export const ScheduleMetaEntitySchema = z.object({
    sortOrder: z.number(),
});

export type ScheduleMetaEntity = z.infer<typeof ScheduleMetaEntitySchema>;
